<template>
  <span />
</template>

<script>
import { createTour, hasTourBeenSeen } from '@/tour'

export default {
  name: 'TourController',
  mounted() {
    if (hasTourBeenSeen()) return

    // Delay to let the sidebar fully render before Shepherd queries the DOM
    setTimeout(() => {
      const tour = createTour()
      tour.start()
    }, 700)
  },
}
</script>
